import type { Chain } from '../../../chain';

export const normalizeAddress = (address: string, chain: Chain) => {
  let normalizedAddress = address;

  if (normalizedAddress?.startsWith('0x')) {
    normalizedAddress = normalizedAddress.slice(2);
  }

  /**
   * These are standard from CAIP-2: https://github.com/ChainAgnostic/CAIPs/blob/master/CAIPs/caip-2.md
   * see also: https://github.com/ChainAgnostic/namespaces
   * note: no standard namespace currently exists for flow
   */
  const chainsThatRequireLowercaseAddress: Chain[] = ['EVM', 'FLOW'];

  normalizedAddress = chainsThatRequireLowercaseAddress.includes(chain)
    ? normalizedAddress?.toLowerCase()
    : normalizedAddress;

  return normalizedAddress;
};
